import { useState, FC } from 'react';
import {
	Collapse as MuiCollapse,
	Divider,
	Box,
	Typography,
	CollapseProps as MuiCollapseProps,
} from '@mui/material';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Icon } from 'shared/ui/Icon';
import { SmallIconButton } from 'shared/ui/SmallIconButton';

type CollapseProps = MuiCollapseProps & {
	title: string;
	count?: number;
	addHandler?: () => void;
};

const Collapse: FC<CollapseProps> = ({ title, children, count, addHandler }) => {
	const [isOpen, setIsOpen] = useState(true);

	return (
		<Box
			sx={{
				'width': '100%',
				'background': ColorPalette.white,
				'borderRadius': '20px',
				'overflow': 'hidden',
				'height': 'fit-content',
				'padding': '25px',
				'@media screen and (min-width: 1441px)': {
					padding: '40px',
				},
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					cursor: 'pointer',
				}}
				onClick={() => setIsOpen(!isOpen)}
			>
				<Typography variant={'h5'} color={ColorPalette.astronaut}>
					{title}
				</Typography>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
					<Typography variant="h5" color={ColorPalette.royalBlue}>
						{count}
					</Typography>
					{addHandler && (
						<SmallIconButton
							iconId="add_round"
							onClick={(e) => {
								e.stopPropagation();
								addHandler();
							}}
						/>
					)}

					<Icon id={'custom_arrow_down'} color={ColorPalette.astronaut} />
				</Box>
			</Box>

			<MuiCollapse in={isOpen} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
				<Divider color={ColorPalette.periwinkle} sx={{ margin: '20px 0 20px' }} />
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>{children}</Box>
			</MuiCollapse>
		</Box>
	);
};

export default Collapse;
